import * as React from "react";
import { useGlobalStores } from "../../../hooks/use_global_stores";
import { useModal } from "../../../hooks/use_modal";
import { FeaturesModal } from "./Components/FeaturesModal";
import { Level } from "../../../config/auth";
import { Feature } from "../../../config/features";
import { Button, Grid } from "@mui/material";

interface IProFieldProps {
    min: Level;
    feature?: Feature;
    label: string;
    children: any;
}

export const ProField = ({min, feature, label, children, ...props}: IProFieldProps) => {
    const { authStore } = useGlobalStores();
    const { open, handleModalOpen, handleModalClose } = useModal();

    if (!authStore.accessToken?.hasAccess(min)) {
        return (
            <>
                <Grid size={{ xs: 12 }}>
                    <Button {...props} onClick={handleModalOpen} variant="contained" color="primary">{label}</Button>
                </Grid>

                <FeaturesModal open={open} onClose={handleModalClose} selectedFeature={feature} />
            </>
        );
    }

    return children;
};
